<template>
    <v-sheet class="ma-0 py-4 pl-4 pr-3" rounded="lg">
        <v-row class="pa-0 align-center" no-gutters>
            <span class="font-weight-medium fontOneToTwo">야간점검일지 등록/수정</span>
            <v-spacer></v-spacer>
            <v-btn
                @click="$emit('offMdl', true)"
                style="margin-top: 2px;" icon>
                <v-icon class="grey006--text" size="30">mdi-close</v-icon>
            </v-btn>
        </v-row>
        <v-divider class="mt-4 mr-1"></v-divider>
        <v-row class="pa-0 mr-1" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="4">
                <span class="font-weight-medium">점검구역</span>
            </v-col>
            <v-col class="px-2 py-1" cols="8">
                <span class="">{{ bscsInfo.inspAreaNm }}</span>
            </v-col>
        </v-row>
        <v-divider class="mr-1"></v-divider>
        <v-row class="pa-0 mr-1" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="4">
                <span class="font-weight-medium">야간점검일</span>
            </v-col>
            <v-col class="px-2 py-1" cols="8">
                <span class="">{{ bscsInfo.inspDtDot }}</span>
            </v-col>
        </v-row>
        <v-divider class="mr-1"></v-divider>
        <v-row class="pa-0 mr-1" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="4">
                <span class="font-weight-medium">점검자</span>
            </v-col>
            <v-col class="pl-2 py-1" cols="8">
                <v-btn
                    color="green002" style="padding: 0 10px 2px 8px !important"
                    @click="onEmpMdl"
                    small>
                    <v-icon class="white--text" style="padding-top: 2px;" size="18">mdi-account-circle-outline</v-icon>
                    <span class="white--text font-weight-bold ml-2" style="padding-top: 1px;">{{ bscsInfo.wrtr }}</span>
                </v-btn>
            </v-col>
        </v-row>
        <v-divider class="mr-1"></v-divider>
        <v-row class="pa-0 mr-1" no-gutters>
            <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="4">
                <span class="font-weight-medium">점검시간</span>
            </v-col>
            <v-col class="pl-2 py-1" cols="8">
                <span class="d-inline-block" style="width: 52px;">
                    <CmmTmField v-model="bscsInfo.inspTm" :required="true"></CmmTmField>
                </span>
            </v-col>
        </v-row>
        <v-divider class="mr-1 mb-5"></v-divider>
        <div v-for="(lst, i) in inspList" :key="i" class="mr-1 mb-4">
            <v-row class="pa-0 align-center" no-gutters>
                <v-icon color="black">mdi-chevron-down</v-icon>
                <span class="ml-1 fontOne font-weight-medium">{{ lst.clsfc3CdNm }}</span>
            </v-row>
            <v-divider class="mx-1 mt-2"></v-divider>
            <div v-for="(rec, j) in lst.recList" :key="j" class="">
                <v-row class="pa-0 mx-1" no-gutters>
                    <v-col class="nmlBfClr-grey001 txtAlgnMid tableBR py-1" cols="5">
                        <span class="fontDotEight">{{ rec.itm1CdNm }}</span>
                    </v-col>
                    <v-col class="pl-1 pt-1" cols="7">
                        <span
                            v-for="(typ, i) in ctmCd" :key="i"
                            class="mr-1" style="padding-bottom: 3px;">
                            <v-btn
                                :class="[rec.itm1Val == typ.valcd ? 'blue001 white--text' : '']"
                                min-width="47" max-width="47" :ripple="false"
                                style="padding: 0px 2px 1px 2px; margin-bottom: 2px;"
                                @click="rec.itm1Val = typ.valcd"
                                small outlined>
                                <span class="fontDotEight">{{ typ.valcdnm }}</span>
                            </v-btn>
                        </span>
                    </v-col>
                </v-row>
                <v-divider class="mx-1"></v-divider>
            </div>
        </div>
        <v-row class="pa-0 align-center" no-gutters>
            <v-icon color="black">mdi-chevron-down</v-icon>
            <span class="ml-1 fontOne font-weight-medium">특이사항</span>
        </v-row>
        <v-row class="pa-0 mx-1 mt-1" no-gutters>
            <v-col class="py-1" cols="12">
                <v-textarea
                    v-model="bscsInfo.cntnt"
                    class="rmrksArea" rows="3"
                    no-resize outlined hide-details dense>
                </v-textarea>
            </v-col>
        </v-row>
        <v-divider class="white mb-4"></v-divider>
        <v-row class="pa-0 justify-center" no-gutters>
            <v-btn
                v-if="bscsInfo.mode == 'modify'"
                :class="[savBtn ? '' : 'grey006 white--text mr-2']"
                @click="delInspRec" :disabled="savBtn"
                outlined rounded small>
                <v-icon class="" size="18">mdi-trash-can-outline</v-icon>
                <span class="fontDotNine mx-1" style="padding-bottom: 1px;">삭제</span>
            </v-btn>
            <v-btn
                :class="[savBtn ? '' : 'blue001 white--text']"
                @click="preInspRec" :disabled="savBtn"
                outlined rounded small>
                <v-icon class="" size="18">mdi-content-save-outline</v-icon>
                <span class="fontDotNine mx-1" style="padding-bottom: 1px;">저장</span>
            </v-btn>
        </v-row>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

import CmmTmField from '../../cmm/CmmTmField.vue';

export default {
    name: 'NtyInspDtlMdl',

    props : {
        sltYMD: { type: String, default: '' },
        sltPk: { type: Number, default: 0 },
        sltOrd: { type: Number, default: 0 }
    },
            
    components: {
      CmmTmField,
    },

    created: function(){
  
    },
    
    mounted: function(){
        //돔 로딩이 끝난 후 작업
        this.$nextTick(function () {
            this.getInspRecItmInf()
        })
    },

    computed: {
        getEmpSlctMdl: function () {
            return this.$store.getters.getSlctEmpMdl
        },
    },

    watch:{
        getEmpSlctMdl: function (v) {
            if(v == false){
                this.bscsInfo.wrtr = this.$store.getters.getSlctEmpObj.name
                this.bscsInfo.wrtrMmbrPk = this.$store.getters.getSlctEmpObj.mmbrPk
            }
        },
    },

    methods: { 
        // 야간점검일지 작성 항목조회
        getInspRecItmInf: function (){
            this.savBtn = true
            this.inspList.splice(0)

            let obj = {}
            obj.inqYMD = this.sltYMD
            obj.inspAreaPk = this.sltPk
            obj.inspOrd = this.sltOrd
       
            http.post('empApp/selInspRecItmInfo', obj)
                .then((response) => ( this.inspRecItmRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selInspRecItmInfo : ' + error))
        },

        inspRecItmRst: function (res){
            if(res.statusCode == 200){
                this.bscsInfo.mode = res.data.mode
                this.bscsInfo.inspRecPk = res.data.inspRecPk
                this.bscsInfo.inspDt = res.data.inspDt
                this.bscsInfo.inspDtDot = this.$moment(res.data.inspDt, 'YYYYMMDD').format('YYYY.MM.DD')
                this.bscsInfo.inspDtlDt = res.data.inspDtlDt
                this.bscsInfo.inspDtlDtDot = this.$moment(res.data.inspDtlDt, 'YYYYMMDD').format('YYYY.MM.DD')
                if(res.data.inspTmHh != '' && res.data.inspTmMm != '')
                    this.bscsInfo.inspTm = res.data.inspTmHh + ':' + res.data.inspTmMm
                if(this.bscsInfo.wrtrMmbrPk == 0){
                    this.bscsInfo.wrtr = this.$store.getters.getUserNm
                    this.bscsInfo.wrtrMmbrPk = this.$store.getters.getUserPk
                }
                else{
                    this.bscsInfo.wrtr = res.data.wrtr
                    this.bscsInfo.wrtrMmbrPk = res.data.wrtrMmbrPk
                }
                this.bscsInfo.inspOrd = res.data.inspOrd
                this.bscsInfo.inspAreaPk = res.data.inspAreaPk
                this.bscsInfo.inspAreaNm = res.data.inspAreaNm
                this.bscsInfo.tkeOvrPk = res.data.tkeOvrPk
                this.bscsInfo.cntnt = res.data.cntnt
                
                this.inspList = res.data.inspList
            }

            this.savBtn = false
        },

        // 야간점검일지 항목 저장
        setInspRecDtl: function (obj){
            http.post('empApp/authInspRecDtl', obj)
                .then((response) => ( this.inspRecRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/authInspRecDtl : ' + error))
        },

        inspRecRst: function (res){
            let obj = {}
            
            if(res.statusCode == 200){
                obj.clr = 'info'
                this.$parent.$parent.$parent.$parent.offInspDtlMdl()
            }
            else
                obj.clr = 'error'

            obj.cntn = res.message

            this.savBtn = false
            this.$store.commit('setCmmAlertMdl', true)
            this.$store.commit('setCmmAlertCntn', obj)
        },

        // 야간점검일지 항목 삭제
        rmInspRecDtl: function (obj){
            http.post('empApp/authDelInspRecDtl', obj)
                .then((response) => ( this.inspRecRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/authDelInspRecDtl : ' + error))
        },

        preInspRec: function (){
            this.savBtn = true

            let obj = {}
            obj.clr = 'info'

            if(this.bscsInfo.wrtrMmbrPk == 0){
                obj.cntn = '점검자를 선택해주세요.'

                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', obj)
                return
            }

            if(!/^([01][0-9]|2[0-3]):([0-5][0-9])$/.test(this.bscsInfo.inspTm)){
                obj.cntn = '점검 시간을 올바르게 입력해주세요.'

                this.$store.commit('setCmmAlertMdl', true)
                this.$store.commit('setCmmAlertCntn', obj)
                return
            }

            let oObj = {}
            oObj.mode = this.bscsInfo.mode
            oObj.inspRecPk = this.bscsInfo.inspRecPk
            oObj.inspDt = this.bscsInfo.inspDt
            oObj.inspTmHh = this.$moment(this.bscsInfo.inspTm, 'HH:mm').format('HH')
            oObj.inspTmMm = this.$moment(this.bscsInfo.inspTm, 'HH:mm').format('mm')
            oObj.wrtr = this.bscsInfo.wrtr
            oObj.wrtrMmbrPk = this.bscsInfo.wrtrMmbrPk
            oObj.inspOrd = this.bscsInfo.inspOrd
            oObj.inspAreaPk = this.bscsInfo.inspAreaPk
            oObj.inspAreaNm = this.bscsInfo.inspAreaNm
            oObj.tkeOvrPk = this.bscsInfo.tkeOvrPk
            oObj.cntnt = this.bscsInfo.cntnt
            oObj.inspList = [...this.inspList]

            //console.log(oObj)
            this.setInspRecDtl(oObj)
        },

        delInspRec: function () {
            let oObj = {}
            oObj.mode = this.bscsInfo.mode
            oObj.inspRecPk = this.bscsInfo.inspRecPk
            oObj.tkeOvrPk = this.bscsInfo.tkeOvrPk
            oObj.cntnt = this.bscsInfo.cntnt
            oObj.inspList = [...this.inspList]

            this.rmInspRecDtl(oObj)
        },

        // 점검자 선택 모달
        onEmpMdl: function () {
            this.$store.commit('setSlctEmpMdl', true)
            this.$store.commit('setSlctEmpDt', this.bscsInfo.inspDt)
        },
    },
    
    data: () => ({
        savBtn: true,
        inspList: [],
        ctmCd: [
            { valcd: '1', valcdnm: '양호' }, { valcd: '2', valcdnm: '보통' }, { valcd: '3', valcdnm: '불량' }
        ],
        bscsInfo: {
            mode: '', inspRecPk: 0, inspDt: '', inspDtDot: '', inspDtlDt: '', inspDtlDtDot: '',
            inspTm: '', wrtr: '', wrtrMmbrPk: 0, inspOrd: 0, inspAreaPk: 0, inspAreaNm: '',
            tkeOvrPk: 0, cntnt: ''
        },
    }),
};
</script>